import React, { Component } from 'react'
import { Form, InputNumber, Input, Button, Modal, Card } from 'antd'
import { connect } from 'react-redux'
import { getContractCodes } from '../../actions'
import MonnifySDK from 'modules/MonnifySDK'
import InternetBankingSimulatorApp from '../../InternetBankingSimulatorApp'
import './style.css'
import Settings from '../../Settings'

const FormItem = Form.Item

const mapStateToProps = state => {
  return {
    contractCodes: state.paymentSimulator.contractCodes,
    merchantCode: window.localStorage.getItem('app.merchantCode'),
    accessToken: window.localStorage.getItem('app.Authorization'),
    settings: state.settings,
  }
}

@connect(
  mapStateToProps,
  { getContractCodes },
)
class PaymentForm extends Component {
  state = { paymentLoading: false, showSettings: false }

  componentDidMount() {
    this.props.getContractCodes()
  }

  initializeSdk = () => {
    const { form } = this.props
    const { apiKey, contractCode } = this.props.settings

    form.validateFields((error, values) => {
      if (!error) {
        const parsedNumber = Number.parseFloat(values.amount).toFixed(2)

        this.setState({ paymentLoading: true })

        MonnifySDK.initialize({
          paymentDescription: values.description,
          amount: parsedNumber,
          currency: 'NGN',
          reference: '' + Math.floor(Math.random() * 1000000000 + 1),
          customerFullName: 'John Doe',
          customerEmail: 'monnify@monnify.com',
          customerMobileNumber: '08163247374',
          apiKey: apiKey,
          contractCode: contractCode,
          callback: response => {
            //process the response here
          },
          onClose: () => {
            this.setState({ paymentLoading: false })
          },
        })
      }
    })
  }

  closeSettingsUI = () => {
    this.setState({ showSettings: false })
  }
  showSettingsUI = () => {
    this.setState({ showSettings: true })
  }

  renderSettings = () => {
    return (
      <Modal
        destroyOnClose={true}
        centered
        className="modal-lg"
        style={{ top: 20 }}
        footer={null}
        onCancel={this.closeSettingsUI}
        width={820}
        visible={this.state.showSettings}
        title={'Simulator Settings'}
      >
        <Settings onCancel={this.closeSettingsUI} />
      </Modal>
    )
  }
  cancelPayment = () => {
    this.setState({ paymentLoading: false })
  }

  renderMobileApp = () => {
    return (
      <Modal
        onCancel={() => {
          this.cancelPayment
        }}
        title={'Bank Mobile App'}
        wrapClassName="ant-modal-centered"
        visible={this.state.paymentLoading}
        footer={null}
        width={null}
      >
        <InternetBankingSimulatorApp />
      </Modal>
    )
  }

  render() {
    const { form } = this.props

    return (
      <Card
        title={<h2>Test Merchant</h2>}
        extra={
          <Button
            onClick={() => this.showSettingsUI()}
            type="primary"
            shape="circle"
            icon="setting"
            size="large"
          />
        }
      >
        <div className="col-md-12 text-center">
          <strong>Make a payment</strong>

          {this.renderMobileApp()}
          {this.renderSettings()}
          <br />
        </div>
        <Form layout="vertical" onSubmit={() => this.initializeSdk()}>
          <div className="col-md-12">
            <FormItem label="Amount">
              {form.getFieldDecorator('amount', {
                rules: [{ required: true, message: 'required' }],
              })(
                <InputNumber
                  style={{ width: '100%' }}
                  precision={2}
                  size="large"
                  placeholder="Transaction Amount"
                />,
              )}
            </FormItem>
          </div>

          <div className="col-md-12">
            <FormItem label="Description">
              {form.getFieldDecorator('description', {
                rules: [
                  { required: true, message: 'required' },
                  { min: 5, message: 'Must be greater than 5 characters' },
                ],
              })(<Input size="large" placeholder="Payment Description" />)}
            </FormItem>
          </div>

          <div className="form-actions text-center">
            <Button
              type="primary"
              className="width-150 mr-4"
              htmlType="submit"
              disabled={this.props.hasErrors(form.getFieldsError())}
              loading={this.state.paymentLoading}
            >
              Make Payment
            </Button>
          </div>
        </Form>
      </Card>
    )
  }
}
export default PaymentForm



// WEBPACK FOOTER //
// ./src/modules/Simulator/MainApp/PaymentSimulationApp/components/PaymentForm.js